const fields = [
  {
    label: "Caption",
    name: "caption",
    type: "text",
    validationType: "string",
  },
  {
    label: "Left Text",
    name: "leftText",
    type: "text",
    validationType: "string",
  },
  {
    label: "Right Text",
    name: "rightText",
    type: "text",
    validationType: "string",
  },
  // {
  //   label: "Show Official Price",
  //   name: "showOfficialPrice",
  //   type: "boolean",
  //   switch: true,
  //   validationType: "boolean",
  // },
  {
    label: "Show  Price",
    name: "showPrice",
    type: "boolean",
    select: true,
    validationType: "number",
  },
  {
    label: "Display Time",
    name: "times",
    type: "number",
    validationType: "array",
    multiSelect: true,
    options: [
      { id: 0, label: "Now" },
      { id: 5, label: "In 5 mins" },
      { id: 10, label: "In 10 mins" },
      { id: 15, label: "In 15 mins" },
      { id: 30, label: "In 30 mins" },
    ],
  },
];

export default fields;
